import React from "react";
import { motion } from "framer-motion";

const fadeIn = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
};

const NEGOCIO_IMG = "https://lh3.googleusercontent.com/p/AF1QipMkmVTAUyiCwh8IPLAYU5k7QA3o74a_3KINGdLi=s680-w680-h510-rw";

// 👇--- AGREGA { onNavigate } COMO PROP AQUÍ ---
const AboutUsSection = ({ onNavigate }) => (
  <motion.section
    className="container mx-auto py-16 flex flex-col md:flex-row items-center justify-center gap-10"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
    variants={fadeIn}
  >
    {/* Imagen del negocio */}
    <div className="flex-shrink-0 w-full max-w-sm mb-8 md:mb-0 md:mr-8 rounded-2xl overflow-hidden shadow-xl border-4 border-blue-200">
      <img
        src={NEGOCIO_IMG}
        alt="Fachada Atlantis Fish"
        className="w-full h-64 object-cover"
        loading="lazy"
      />
    </div>
    {/* Texto y botón */}
    <div className="flex-1 max-w-xl text-center md:text-left">
      <h2 className="text-3xl sm:text-4xl font-extrabold mb-4 text-blue-800">Sobre Atlantis Fish</h2>
      <p className="text-gray-700 mb-6 text-lg leading-relaxed">
        En <strong>Atlantis Fish</strong> somos más que una tienda, somos apasionados por la acuariofilia y el bienestar animal. Aquí encuentras todo lo relacionado con el mundo acuático: peces exóticos, acuarios, filtros, accesorios, alimentos y la mejor asesoría para principiantes y expertos.<br /><br />
        Te acompañamos desde la elección de tu primer pez, el montaje de tu acuario, hasta tips de mantenimiento y salud. ¡Ven y vive la experiencia Atlantis!
      </p>
      <button
        onClick={() => onNavigate('sobre-nosotros')}
        className="inline-block bg-gradient-to-r from-blue-600 to-cyan-400 text-white px-8 py-4 rounded-2xl font-bold text-lg shadow-lg hover:scale-105 hover:shadow-2xl transition-all"
      >
        Conócenos más
      </button>
    </div>
  </motion.section>
);

export default AboutUsSection;
